import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FIPLanding from "./pages/FIPLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FIPLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
